export enum ArchiveKarousselProjection {
  DEFAULT = 'DEFAULT',
  MES_ARCHIVES = 'MES_ARCHIVES',
}